import config from 'config'
import queryString from 'query-string'

import { NERDWALLET } from '../const'

export function getTooltipContent(lenderSlug) {
  switch (lenderSlug) {
    case 'sofi':
      return 'With all discounts.'
    case 'earnest':
      return 'Actual rate and available repayment terms will vary based on your income. Fixed rates range from 4.54% APR to 10.14% APR (excludes 0.25% Auto Pay discount). Variable rates range from 6.13% APR to 10.24% APR (excludes 0.25% Auto Pay discount). Earnest variable interest rate student loan refinance loans are based on a publicly available index, the 30-day Average Secured Overnight Financing Rate (SOFR) published by the Federal Reserve Bank of New York. The variable rate is based on the rate published on the 25th day, or the next business day, of the preceding calendar month, rounded to the nearest hundredth of a percent. The rate will not increase more than once per month. The maximum rate for your loan is 8.95% if your loan term is 10 years or less. For loan terms of more than 10 years to 15 years, the interest rate will never exceed 9.95%. For loan terms over 15 years, the interest rate will never exceed 11.95%. Please note, we are not able to offer variable rate loans in AK, IL, MN, NH, OH, TN, and TX. Our lowest rates are only available for our most credit qualified borrowers and contain our .25% auto pay discount from a checking or savings account.'
    case 'cas':
    case 'sallie-mae':
      return 'The annual percentage rate (APR) includes your interest rate, any loan fees and discounts. It reflects the total cost of borrowing.'
    default:
      return null
  }
}

export function getInfoRows(lender, { hideMinCreditScore = false } = {}) {
  const { minFixedRate, maxFixedRate, minVariableRate, maxVariableRate, minCreditScore, slug } =
    lender || {}

  return [
    {
      title: 'Fixed APR',
      value: `${minFixedRate || ''} - ${maxFixedRate || ''}%`,
      tooltipContent: getTooltipContent(slug),
    },
    {
      title: 'Variable APR',
      value: `${minVariableRate || ''} - ${maxVariableRate || ''}%`,
      tooltipContent: getTooltipContent(slug),
    },
    ...(hideMinCreditScore
      ? []
      : [
          {
            title: 'Min. credit score',
            value: minCreditScore || '-',
          },
        ]),
  ]
}

export function getReviewUrl(slug, theme) {
  const lenderSlugMap = {
    cas: 'college-ave',
  }
  const lenderSlug = lenderSlugMap[slug] || slug

  switch (theme) {
    case NERDWALLET:
      return `https://www.nerdwallet.com/reviews/loans/student-loans/${lenderSlug}-student-loans`

    default:
      return null
  }
}

const LENDER_NAME_MAP = {
  sofi: 'sofi-ad-tile',
}

const VERTICAL_MAP = {
  'student-loan-refi': 'student-loan-refinance',
  'student-loan': 'student-loan',
}

export function sliceUtmCampaign(utmCampaign) {
  if (utmCampaign && utmCampaign.length > 255) {
    return utmCampaign.slice(0, 255)
  }
  return utmCampaign
}

export function getHrefParams({ lenderSlug, position, pageUrl, uniqueId, vertical, theme }) {
  const lenderName = LENDER_NAME_MAP[lenderSlug] || lenderSlug

  return {
    url: `${config.credibleRoot}/redirect`,
    query: {
      lender_name: lenderName,
      vertical: VERTICAL_MAP[vertical],
      tile_position: position,
      page_url: pageUrl,
      utm_source: theme,
      utm_medium: 'partner_integration',
      utm_campaign: sliceUtmCampaign(pageUrl),
      utm_referrer: document?.referrer,
      utm_content: uniqueId,
      click_type: 'cta_click',
    },
  }
}

export const getRedirectHrefWithParams =
  (_params) =>
  (flow, extraParams = {}) => {
    const params = getHrefParams(_params)

    return queryString.stringifyUrl({
      url: params.url,
      query: {
        ...params.query,
        ...extraParams,
        flow,
      },
    })
  }
